import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { useLanguage } from '../i18n/LanguageContext';
import { FaCheckCircle, FaArrowRight } from 'react-icons/fa';

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 60px 20px;
  text-align: center;
`;

const SuccessIcon = styled.div`
  font-size: 5rem;
  color: #22c55e;
  margin-bottom: 2rem;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  color: #333;
`;

const Button = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.75rem 2rem;
  background-color: #4f46e5;
  color: white;
  font-weight: 600;
  border-radius: 0.5rem;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: #4338ca;
  }
`;

const SubscriptionSuccess: React.FC = () => {
  const { language } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();
  const [sessionId, setSessionId] = useState<string | null>(null);

  useEffect(() => {
    // 解析URL参数获取session_id
    const query = new URLSearchParams(location.search);
    const sessionId = query.get('session_id');
    setSessionId(sessionId);
  }, [location.search]);

  const handleManageBilling = async () => {
    if (!sessionId) return;

    try {
      const response = await fetch('https://create-portal-session-4lwrmzn6aa-uc.a.run.app', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          session_id: sessionId,
          return_url: `${window.location.origin}/my-subscription`
        }),
      });

      if (!response.ok) {
        throw new Error(language === 'zh' ? '无法创建管理会话' : 'Failed to create portal session');
      }

      const data = await response.json();
      if (data && data.url) {
        window.location.href = data.url; // 重定向到 Stripe 订单管理页面
      } else {
        throw new Error(language === 'zh' ? '未获取到有效的管理URL' : 'Invalid portal URL');
      }
    } catch (error) {
      console.error('管理会话错误:', error);
      alert(language === 'zh' ? '创建管理会话失败，请稍后再试' : 'Failed to create portal session. Please try again later.');
    }
  };

  return (
    <Container>
      <SuccessIcon>
        <FaCheckCircle />
      </SuccessIcon>
      
      <Title>{language === 'zh' ? '订阅成功！' : 'Subscription Successful!'}</Title>
      
      <Button onClick={handleManageBilling}>
        {language === 'zh' ? '管理账单信息' : 'Manage your billing information'} 
        <FaArrowRight />
      </Button>
    </Container>
  );
};

export default SubscriptionSuccess; 